import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import { SettingsProvider } from './context/SettingsContext';
import { TeamProvider } from './context/TeamContext';
import ProtectedRoute from './components/ProtectedRoute';

// Layouts
import PublicLayout from './layouts/PublicLayout';
import AdminLayout from './layouts/AdminLayout';

// Pages publiques
import HomePage from './pages/public/HomePage';
import ServicesPage from './pages/public/ServicesPage';
import ServiceDetailPage from './pages/public/ServiceDetailPage';
import AboutPage from './pages/public/AboutPage';
import TestimonialsPage from './pages/public/TestimonialsPage';
import BlogPage from './pages/public/BlogPage';
import ArticlePage from './pages/public/ArticlePage';
import ContactPage from './pages/public/ContactPage';
import ApplicationsPage from './pages/public/ApplicationsPage';
import ApplicationDetailPage from './pages/public/ApplicationDetailPage';

// Pages admin
import LoginPage from './pages/admin/LoginPage';
import DashboardPage from './pages/admin/DashboardPage';
import AdminServicesPage from './pages/admin/ServicesPage';
import AdminApplicationsPage from './pages/admin/ApplicationsPage';
import AdminArticlesPage from './pages/admin/ArticlesPage';
import AdminTestimonialsPage from './pages/admin/TestimonialsPage';
import AdminTeamPage from './pages/admin/TeamPage';
import ContactsPage from './pages/admin/ContactsPage';
import MediaPage from './pages/admin/MediaPage';
import UsersPage from './pages/admin/UsersPage';
import SettingsPage from './pages/admin/SettingsPage';
import StatsPage from './pages/admin/StatsPage';
import AdminFeaturesPage from './pages/admin/FeaturesPage';
import AdminCertificationsPage from './pages/admin/CertificationsPage';

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <TeamProvider>
          <Router>
            <Routes>
              {/* Routes publiques */}
              <Route path="/" element={<PublicLayout />}>
                <Route index element={<HomePage />} />
                <Route path="services" element={<ServicesPage />} />
                <Route path="services/:slug" element={<ServiceDetailPage />} />
                <Route path="nos-applications" element={<ApplicationsPage />} />
                <Route path="nos-applications/:slug" element={<ApplicationDetailPage />} />
                <Route path="a-propos" element={<AboutPage />} />
                <Route path="temoignages" element={<TestimonialsPage />} />
                <Route path="blog" element={<BlogPage />} />
                <Route path="blog/:slug" element={<ArticlePage />} />
                <Route path="contact" element={<ContactPage />} />
              </Route>

              {/* Routes admin */}
              <Route path="/admin/login" element={<LoginPage />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<DashboardPage />} />
                <Route path="services" element={<AdminServicesPage />} />
                <Route path="applications" element={<AdminApplicationsPage />} />
                <Route path="articles" element={<AdminArticlesPage />} />
                <Route path="testimonials" element={<AdminTestimonialsPage />} />
                <Route path="team" element={<AdminTeamPage />} />
                <Route path="contacts" element={<ContactsPage />} />
                <Route path="medias" element={<MediaPage />} />
                <Route path="users" element={<UsersPage />} />
                <Route path="settings" element={<SettingsPage />} />
                <Route path="stats" element={<StatsPage />} />
                <Route path="features" element={<AdminFeaturesPage />} />
                <Route path="certifications" element={<AdminCertificationsPage />} />
              </Route>
            </Routes>
          </Router>
          <Toaster position="top-right" />
        </TeamProvider>
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;